import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { priceBYN } from "../../../../utils/formatHelpers";
import { PAYMENT_METHOD } from "./PaymentInput";
import { cartSelectors } from "../../_core/cartSelectors";
import { updareCartPrepareCharge } from "../../_core/cartActions";
import {CART_SHIPPING_TYPES} from "../../_core/cartConstants";

export const TotalInput = () => {
    const dispatch = useDispatch();
    const priceSpecification = useSelector(cartSelectors.priceSpecification) || {};
    const [value, setValue] = useState(priceSpecification.prepareChangeFor);
    const shipping = useSelector(cartSelectors.shipping);
    const isDelivery = shipping.shippingType === CART_SHIPPING_TYPES.delivery;

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const handleBlur = () => {
        dispatch(updareCartPrepareCharge({
            prepare_change_for: value,
        }));
    }
    let discountTitle = 'скидка'
    if (priceSpecification.discountState?.get('promo') === 'preorder_pickup_discount') {
        discountTitle = 'скидка на предварительный заказ'
    }

    return (
        <div className="form-payments-and-total-general" style={{marginLeft: '20px'}}>
            {(priceSpecification.discountState?.get('percent') > 0 || priceSpecification.deliveryCost > 0) && (
                <>
                    <span className={'form-payments-and-total-general__label ' + priceSpecification}>стоимость заказа</span>
                    <strong className={("form-payments-and-total-general__total " + (priceSpecification?.discountState?.get('percent') > 0 ? 'text-line-through' : ''))}>{priceBYN(priceSpecification.rawItemsPrice)}</strong><br/>
                    </>
                )
            }

            {!!priceSpecification.discountItemsAmount && (
                <>
                    <span className="form-payments-and-total-general__label">{discountTitle}</span>
                    {
                        !!priceSpecification.discountState.get('percent') && (
                            <strong className="form-payments-and-total-general__total">{priceSpecification.discountState.get('percent')}%</strong>
                        )
                    }
                    {
                        !priceSpecification.discountState.get('percent') && (
                            <strong className="form-payments-and-total-general__total">{priceSpecification.discountItemsAmount}</strong>
                        )
                    }
                    <br/>
                </>
            )}

            {isDelivery && (
                <>
                    <span className="form-payments-and-total-general__label">стоимость доставки</span>
                    <strong className="form-payments-and-total-general__total">{priceBYN(priceSpecification.deliveryCost)}</strong><br/>

                </>
            )}

            <div>
                <span className="form-payments-and-total-main-general__label">итого</span>
                <strong className="form-payments-and-total-main-general__total">{priceBYN(priceSpecification.orderTotal)}</strong><br/>
            </div>

            {priceSpecification.deliveryCost > 0 && isDelivery && (
            <div>
                <span className="form-total-order-for-free-delivery">сумма заказа для бесплатной доставки от {priceBYN(priceSpecification.minOrderPriceForDelivery)} руб</span>
            </div>
            )}


            {priceSpecification?.paymentType === PAYMENT_METHOD.cash.id && (
                <div className="form-payments-and-total__cash-payment-renting">
                    <div className="label">
                        С какой суммы подготовить сдачу?
                    </div>
                    <div className="input">
                        <input className="form-input form-size-full"
                               type="text"
                               value={value}
                               onBlur={handleBlur}
                               onChange={handleChange}/>
                    </div>
                </div>
            )}
        </div>
    )
};
